/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Form } from '@organisms';

import AthleteSelect from '../AthleteSelect';

const AthleteField = ({ onChange, ...props }) => (
  <Form.Item {...props}>
    <AthleteSelect onChange={onChange} />
  </Form.Item>
);

export default AthleteField;
